import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '.'

interface OrdersState {
  newOrders: string[]
}

const initialState: OrdersState = {
  newOrders: [],
}

export const slice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    reset: (state) => {
      state.newOrders = []
    },
  },
})

// --- SELECTORS --- //

export const selectOrders = (state: RootState) => state.orders
